export const FETCH_CHART_ACCOUNTS = 'FETCH_CHART_ACCOUNTS';
export const FETCH_CHART_ACCOUNTS_SUCCESS = 'FETCH_CHART_ACCOUNTS_SUCCESS';
export const FETCH_CHART_ACCOUNTS_FAILURE = 'FETCH_CHART_ACCOUNTS_FAILURE';
export const FETCH_INITIAL_DATA_FOR_CHART_MODAL_SUCCESS = 'FETCH_INITIAL_DATA_FOR_CHART_MODAL_SUCCESS';
export const SAVING_CHART = 'SAVING_CHART';
export const SAVING_CHART_SUCCESS = 'SAVING_CHART_SUCCESS';
export const SAVING_CHART_FAILURE = 'SAVING_CHART_FAILURE';
export const FETCH_INITIAL_DATA_FOR_CHART_ACCOUNT_MODAL = 'FETCH_INITIAL_DATA_FOR_CHART_ACCOUNT_MODAL';
export const FETCH_INITIAL_DATA_FOR_CHART_ACCOUNT_MODAL_SUCCESS = 'FETCH_INITIAL_DATA_FOR_CHART_ACCOUNT_MODAL_SUCCESS';
export const FETCH_INITIAL_DATA_FOR_CHART_ACCOUNT_MODAL_FAILURE = 'FETCH_INITIAL_DATA_FOR_CHART_ACCOUNT_MODAL_FAILURE';
export const SAVING_CHART_ACCOUNT_SUCCESS = 'SAVING_CHART_ACCOUNT_SUCCESS';
export const SAVING_CHART_ACCOUNT_FAILURE = 'SAVING_CHART_ACCOUNT_FAILURE';
export const REMOVING_CHART_ACCOUNT = 'REMOVING_CHART_ACCOUNT';
export const REMOVING_CHART_ACCOUNT_SUCCESS = 'REMOVING_CHART_ACCOUNT_SUCCESS';
export const REMOVING_CHART_ACCOUNT_FAILURE = 'REMOVING_CHART_ACCOUNT_FAILURE';
export const SAVING_CHART_ACCOUNT = 'SAVING_CHART_ACCOUNT';
export const SELECT_PERIOD = 'SELECT_PERIOD';
export const SELECT_CHART = 'SELECT_CHART';
export const FETCH_CHARTS_SUCCESS = 'FETCH_CHARTS_SUCCESS';
export const FETCH_CHART_EDIT_VALIDATION_SUCCESS = 'FETCH_CHART_EDIT_VALIDATION_SUCCESS';
export const REMOVING_CHART = 'REMOVING_CHART';
export const REMOVING_CHART_SUCCESS = 'REMOVING_CHART_SUCCESS';
export const REMOVING_CHART_FAILURE = 'REMOVING_CHART_FAILURE';

export const IMPORT_CHART_OF_ACCOUNTS = 'IMPORT_CHART_OF_ACCOUNTS';
export const IMPORT_CHART_OF_ACCOUNTS_SUCCESS = 'IMPORT_CHART_OF_ACCOUNTS_SUCCESS';
export const IMPORT_CHART_OF_ACCOUNTS_FAILURE = 'IMPORT_CHART_OF_ACCOUNTS_FAILURE';

